import { Link } from "react-router-dom";
import { MapPin, Mail, Instagram } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <footer data-testid="main-footer" className="footer">
      <div className="container-custom px-4 sm:px-6">
        <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-8 sm:gap-12 mb-8 sm:mb-12">
          {/* Brand */}
          <div className="col-span-2 sm:col-span-2 lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-3 sm:mb-4">
              <MapPin className="w-5 h-5 sm:w-6 sm:h-6 text-[#E29578]" />
              <span className="font-heading font-bold text-lg sm:text-xl text-white">
                {t("nav.brand")}
              </span>
            </Link>
            <p className="text-xs sm:text-sm text-white/70 mb-4 sm:mb-6">
              {t("footer.tagline")}
            </p>
            <div className="flex gap-2 sm:gap-3">
              <a
                href="https://instagram.com/discover_cancun"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="social-instagram"
                className="social-icon w-9 h-9 sm:w-10 sm:h-10"
                aria-label="Instagram"
              >
                <Instagram className="w-4 h-4 sm:w-5 sm:h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading font-semibold text-white text-sm sm:text-base mb-3 sm:mb-4">
              {t("footer.quick_links")}
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/tours" data-testid="footer-link-tours" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.all_tours")}
                </Link>
              </li>
              <li>
                <Link to="/tours?category=beach" data-testid="footer-link-beach" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.beach_tours")}
                </Link>
              </li>
              <li>
                <Link to="/tours?category=archaeological" data-testid="footer-link-archaeological" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.archaeological")}
                </Link>
              </li>
              <li>
                <Link to="/tours?category=adventure" data-testid="footer-link-adventure" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.adventure")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Resources */}
          <div>
            <h4 className="font-heading font-semibold text-white text-sm sm:text-base mb-3 sm:mb-4">
              {t("footer.resources")}
            </h4>
            <ul className="space-y-2 sm:space-y-3">
              <li>
                <Link to="/guide" data-testid="footer-link-weather" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.travel_guide")}
                </Link>
              </li>
              <li>
                <Link to="/guide" data-testid="footer-link-safety" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.safety_tips")}
                </Link>
              </li>
              <li>
                <Link to="/about" data-testid="footer-link-about" className="text-xs sm:text-sm hover:text-[#83C5BE]">
                  {t("footer.about_us")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div className="hidden lg:block">
            <h4 className="font-heading font-semibold text-white mb-4">
              {t("footer.contact_us")}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <Mail className="w-5 h-5 text-[#E29578] flex-shrink-0 mt-0.5" />
                <a
                  href="mailto:hello@discover-cancun.com"
                  data-testid="footer-email"
                  className="text-sm hover:text-[#83C5BE]"
                >
                  hello@discover-cancun.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-white/10 pt-6 sm:pt-8">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 sm:gap-4">
            <p className="text-xs sm:text-sm text-white/50 text-center sm:text-left">
              &copy; {currentYear} Discover Cancun
            </p>
            <div className="flex flex-wrap justify-center gap-3 sm:gap-6 text-xs sm:text-sm">
              <a href="#" className="text-white/50 hover:text-white/70">
                {t("footer.privacy")}
              </a>
              <a href="#" className="text-white/50 hover:text-white/70">
                {t("footer.terms")}
              </a>
              <span className="affiliate-badge text-[10px] sm:text-xs">
                {t("footer.affiliate_partner")}
              </span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
